<template>
  <ul class="flex flex-wrap items-center">
    <li
      v-for="logo in blok.logos"
      :key="logo.id"
      class="flex h-32 items-center justify-center lg:h-36"
      :class="listItemClass"
    >
      <img
        :src="
          getImgSrc({
            imgUrl: logo?.filename,
            trim: 'color',
            trimColor: 'ffffff',
            width: 160,
          })
        "
        :alt="logo?.alt || `${getFileNameFromUrl(logo?.filename)} logo`"
        class="block h-auto w-28 py-2 md:py-0 lg:w-32"
        :class="[blok.muted ? 'grayscale hover:grayscale-0' : '']"
        loading="lazy"
      />
    </li>
  </ul>
</template>

<script setup>
import { getImgSrc, getFileNameFromUrl } from '../utils/imgUtils'

defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
  listItemClass: {
    type: String,
    default: '',
  },
})
</script>
